import React, { useState } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { RiMenu3Fill } from "react-icons/ri";
import logo from "../assets/logo1.png";

const MobileNav = () => {
  const [menuShow, setMenuShow] = useState(false);
  return (
    <>
      <MobileMain>
        <MobileContianer>
          <Link to="/">
            <div>
              <img src={logo} alt="" />
            </div>
          </Link>
          {menuShow === false ? (
            <div onClick={() => setMenuShow(true)}>
              <RiMenu3Fill className="icon" />
            </div>
          ) : null}
        </MobileContianer>
      </MobileMain>
      {menuShow === true ? (
        <>
          <Overlay onClick={() => setMenuShow(false)}></Overlay>
          <Sidebar>
            <img src={logo} alt="" className="sidebar_img" />
            <ul>
              <li onClick={() => setMenuShow(false)}>
                <Link to="/">Home</Link>
              </li>
              <li onClick={() => setMenuShow(false)}>
                <Link to="/pricing">Pricing</Link>
              </li>
              <li onClick={() => setMenuShow(false)}>
                <Link to="/support">Support</Link>
              </li>
              <li onClick={() => setMenuShow(false)}>
                <Link to="/contact-us">Contact Us</Link>
              </li>
              <li onClick={() => setMenuShow(false)}>
                <SignUp to="/sign-up">Sign Up</SignUp>
              </li>
            </ul>
          </Sidebar>
          <Close className="closeIcon" onClick={() => setMenuShow(false)}>
            <i class="fa-solid fa-xmark"></i>
          </Close>
        </>
      ) : null}
    </>
  );
};

export default MobileNav;

const Overlay = styled.div`
  position: fixed;
  left: 0%;
  top: 0%;
  width: 100%;
  height: 320%;
  background-color: #000;
  opacity: 0.7;
  z-index: 10;
  overflow: hidden;
`;

const Close = styled.div`
  position: fixed;
  right: 4%;
  top: 4%;
  z-index: 100;
  color: #fff !important;
  cursor: pointer;

  i {
    font-size: 30px;
  }
`;

const Sidebar = styled.div`
  position: fixed;
  top: 0%;
  left: 0%;
  height: 100%;
  width: 320px;
  background-color: rgb(169, 248, 186);
  z-index: 1000000000000;
  overflow: hidden;
  transition: all 0.2s ease-out;
  padding: 10px 17px;

  .sidebar_img {
    width: 170px;
    height: 60px;
  }
  ul {
    list-style: none;
    margin: 1.5rem 1rem;
    li {
      margin-bottom: 30px;
      a {
        font-size: 20px;
        font-weight: 500;
        color: rgb(32, 32, 79);
      }
    }
  }
`;

const SignUp = styled(Link)`
  padding: 10px 30px;
  margin-top: 1.2rem !important;
  text-decoration: none;
  border-radius: 8px;
  background-color: #3aaa35;
  color: #fff !important;
  font-size: 18px;
  font-weight: 500;
  cursor: pointer;
`;

const MobileMain = styled.div`
  display: none;
  @media only screen and (max-width: 991px) {
    display: block;
    padding: 10px 10px;
  }
`;

const MobileContianer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  div {
    img {
      width: 170px;
      height: 60px;
    }
    .icon {
      font-size: 30px;
      color: #333;
    }
  }
`;
